import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://localhost:8000', // Replace with your backend URL
 
  // baseURL: 'https://3.110.105.207:8000/', // Replace with your backend URL
  baseURL: 'https://adminapi.heliumlearn.com/', // Replace with your backend URL
  // timeout: 5000, // Set the timeout for requests (optional)
  headers: {
    'Content-Type': 'application/json', // Adjust the content type as per your backend requirements
  },
});

export default instance;
